import Icon from "@mui/icons-material/SupervisorAccountTwoTone";
import List from "./list";
import Edit from "./edit";
import Create from "./create";

export default {
  list: List,
  edit: Edit,
  create: Create,
  icon: Icon,
  label: "Admin",
  options: { label: "Admin" },
  name: "admins",
};
